import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FilmStripLoader from '../components/FilmStripLoader';
import SignOutOtherDevicesModal from '../components/SignOutOtherDevicesModal';

import loginBg from "../../src/assets/images/login.png";


const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate page load
    setTimeout(() => {
      setIsLoading(false);
      setTimeout(() => {
        setShowLoader(false);
      }, 600);
    }, 500);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');


    try {
      const result = await login(formData.email, formData.password);
      
      
      // Check if login requires signing out from other devices
      if (result && result.requiresSignOut) {
        setShowSignOutModal(true);
        setLoading(false);
        return;
      }

      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Échec de la connexion. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  const handleSignOutOtherDevices = () => {
    setShowSignOutModal(false);
    // Context is already updated in modal, just navigate
    navigate('/');
  };

  const handleCancelSignOut = () => {
    setShowSignOutModal(false);
    setFormData({ email: '', password: '' });
  };

  if (showLoader) {
    return (
      <div className={isLoading ? '' : 'fade-out-loader'}>
        <FilmStripLoader />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#141414] flex flex-col overflow-x-hidden">
      <Header />

      <div className="flex-1 w-full max-w-[1240px] mx-auto px-4 py-12 flex items-center justify-center">
        <div className="w-full flex items-center gap-10 justify-center">
          <img
            src={loginBg}
            className="hidden min-[1080px]:block w-[700px] h-[576px] object-cover animate-page-enter"
            alt="img"
          />

          <div className="w-full max-w-[520px] bg-[#1A1A1A] rounded-3xl p-6 sm:p-8 shadow-xl flex flex-col gap-5 border border-[#262626] animate-page-enter animate-page-enter-delay-1">
            <h1 className="text-3xl font-bold text-white mb-2 text-center">
              Bienvenue sur H4KIG
            </h1>

            {/* Tabs */}
            <div className="w-full max-w-[420px] mx-auto flex gap-2 mb-2 bg-[#FFFFFF1C] p-2 rounded-full">
              <button className="flex-1 px-5 sm:px-10 py-2 bg-white text-black rounded-full whitespace-nowrap">
                Connexion
              </button>
              <Link
                to="/register"
                className="flex-1 px-5 sm:px-10 py-2 bg-transparent text-white hover:bg-white hover:text-black transition rounded-full text-center whitespace-nowrap"
              >
                Inscription
              </Link>
            </div>

            <p className="text-white/80 text-center mb-2">
              Connectez-vous pour accéder à votre compte et commencer à regarder.
            </p>

            {error && (
              <div className="p-3 bg-red-900/50 border border-red-700 rounded text-red-200 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-white mb-2">Identifiant</label>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Entrez votre e-mail ou nom d'utilisateur"
                  className="w-full px-4 py-3 bg-transparent text-white rounded-lg border border-white/60 focus:border-white focus:outline-none"
                  required
                />
              </div>

              <div>
                <label className="block text-white mb-2">Mot de passe</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Entrez votre mot de passe"
                    className="w-full px-4 py-3 bg-transparent text-white rounded-lg border border-white/60 focus:border-white focus:outline-none pr-12"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                  >
                    {showPassword ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="text-center py-2">
                <Link to="/forgot-password" className="text-gray-400 hover:text-white transition">
                  Mot de passe oublié ?
                </Link>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-white text-black rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Connexion...' : 'Se connecter'}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />

      {showSignOutModal && (
        <SignOutOtherDevicesModal
          isOpen={showSignOutModal}
          onClose={handleCancelSignOut}
          onConfirm={handleSignOutOtherDevices}
          email={formData.email}
          password={formData.password}
        />
      )}
    </div>
  );
};

export default Login;
